import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE + '/api/admin/special-templates'

export default {
  namespaced: true,
  state: {
    specialTemplates: [],
    is_loading: false,
    is_processing: false
  },
  mutations: {
    SET_SPECIAL_TEMPLATES (state, templates) {
      state.specialTemplates = templates
    },
    SET_LOADING (state, status) {
      state.is_loading = status
    },
    SET_PROCESSING (state, status) {
      state.is_processing = status
    }
  },
  actions: {
    async fetchSpecialTemplates ({ commit }) {
      try {
        commit('SET_LOADING', true)
        const response = await axios.get(baseURL)
        commit('SET_SPECIAL_TEMPLATES', response.data.data)
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    showSpecialTemplate ({ commit }, id) {
      return axios.get(baseURL + '/' + id)
    },
    async createSpecialTemplate ({ commit }, data) {
      commit('SET_PROCESSING', true)
      const promise = axios.post(baseURL, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      promise.finally(() => {
        commit('SET_PROCESSING', false)
      })

      return promise
    },
    async updateSpecialTemplate ({ commit }, {
      id,
      data
    }) {
      commit('SET_PROCESSING', true)
      const promise = axios.post(`${baseURL}/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      promise.finally(() => {
        commit('SET_PROCESSING', false)
      })

      return promise
    },
    async deleteSpecialTemplate ({ commit }, id) {
      commit('SET_PROCESSING', true)
      const promise = axios.delete(`${baseURL}/${id}`)
      promise.finally(() => {
        commit('SET_PROCESSING', false)
      })

      return promise
    }
  }
}
